import { EDITABLE_NUMBER_CELL_ATTR } from 'components/common/EditableCell';

export const STEP_NAV_COL_RATE = 'rate';
export const STEP_NAV_COL_COST = 'cost';
export const STEP_NAV_COL_PRODUCTION_YIELD = 'productionYield';
export const STEP_NAV_COL_PRODUCTION_PRICE = 'productionPrice';

export const STEP_NAV_COL_ATTR = 'data-step-nav-col';

/** The new layout's per-scenario production columns, e.g. "production-yieldLow". */
export const productionSheetNavColumn = (key: string) => `production-${key}`;

/**
 * Moves focus to the nearest editable cell in the same step-grid column,
 * skipping rows whose cell is read-only or disabled. No-op at the grid edges.
 * Focusing the EditableCell root puts it straight into edit mode.
 */
export const focusAdjacentStepCell = (
  direction: 'up' | 'down',
  from: HTMLElement
) => {
  const currentCell = from.closest<HTMLTableCellElement>(
    `td[${STEP_NAV_COL_ATTR}]`
  );
  const table = currentCell?.closest('table');
  if (!currentCell || !table) return;

  const column = currentCell.getAttribute(STEP_NAV_COL_ATTR);
  const columnCells = Array.from(
    table.querySelectorAll<HTMLTableCellElement>(
      `td[${STEP_NAV_COL_ATTR}="${column}"]`
    )
  );
  const step = direction === 'up' ? -1 : 1;

  for (
    let index = columnCells.indexOf(currentCell) + step;
    index >= 0 && index < columnCells.length;
    index += step
  ) {
    const target = columnCells[index].querySelector<HTMLElement>(
      `[${EDITABLE_NUMBER_CELL_ATTR}]:not([aria-disabled="true"])`
    );
    if (target) {
      target.focus();
      return;
    }
  }
};
